import React, { useState, useCallback, useEffect } from 'react';

import moment from 'moment';

const CountDown = React.memo(
  ({
    date = '', // YYYY-MM-DD
  }) => {
    let timer = null;
    const [timeToString, setTimeToString] = useState(null);

    const timeNumberToString = useCallback(number => {
      return `${number < 10 ? `0${number}` : number}`;
    }, []);

    useEffect(() => {
      if (date) {
        timer = setInterval(() => {
          const now = moment().toDate();

          const targetDate = moment(`${date}T23:59:59`).toDate();

          const distance = (targetDate - now) / 1000;

          let time = {
            hh: timeNumberToString(Math.floor(distance / (60 * 60))),
            mm: timeNumberToString(Math.floor((distance / 60) % 60)),
            ss: timeNumberToString(Math.floor(distance % 60)),
          };

          if (distance > 0) {
            setTimeToString(`${time.hh}:${time.mm}:${time.ss}`);
          } else {
            setTimeToString(`종료`);
            clearInterval(timer);
          }

          console.log({ distance, time });
        }, 1000);
      } else {
        setTimeToString(``);
      }

      return () => {
        if (timer) {
          clearInterval(timer);
        }
      };
    }, []);

    return timeToString;
  },
);

export default CountDown;
